package one.healthium.intercom

import one.healthium.domain.user.UserModel
import one.primehealth.app.BaseAppConfig

expect object IntercomPlatform {
    suspend fun boot()
    suspend fun present(user: UserModel)
    suspend fun shutdown()
}

internal fun buildAttributesMap(user: UserModel, baseAppConfig: BaseAppConfig): Map<String, String?> = mapOf(
    "app_name" to baseAppConfig.intercomAppName,
    "subscription" to user.purchases.subscription.name,
    "purchase_type" to user.purchases.purchaseType,
    "subscription_id" to user.purchases.subscriptionId,
    "email" to user.profile.email,
)
